var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarcodeScanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "2 2 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fff",
    fill: "none",
    d: "M 6 6 L 6 18 M 8.5 6 L 8.5 18 M 13.5 6 L 13.5 18 L 15.5 18 L 15.5 6 Z M 18 6 L 18 18 M 11 6 L 11 18 M 14.5 6 L 14.5 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#397cfc",
    fill: "none",
    d: "M 6 3 L 5 3 C 4 3 3 4 3 5 L 3 6 M 3 18 L 3 19 C 3 20 4 21 5 21 L 6 21 M 18 21 L 19 21 C 20 21 21 20 21 19 L 21 18 M 21 6 L 21 5 C 21 4 20 3 19 3 L 18 3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeScanner);
export default __webpack_public_path__ + "static/media/barcode-scanner.7a53fa3b1381bf5b25031247eb0c2a89.svg";
export { ForwardRef as ReactComponent };